/* eslint-disable @typescript-eslint/no-explicit-any */
// TODO: This file was automatically migrated to TypeScript by `dev typescript migrate`.
//  The eslint disable comment above should be removed and the resulting errors fixed.
/* eslint-disable
    jsx-a11y/iframe-has-title
*/
// TODO: This file was created by bulk-decaffeinate.
// Fix any style issues and re-enable lint.
/*
 * decaffeinate suggestions:
 * DS102: Remove unnecessary code created because of implicit returns
 * DS205: Consider reworking code to avoid use of IIFEs
 * DS207: Consider shorter variations of null checks
 * Full docs: https://github.com/decaffeinate/decaffeinate/blob/master/docs/suggestions.md
 */
import $ from 'jquery';
import React from 'react';

import TFIAccountIcon from 'notebook/tfi/TFIAccountIcon';
import {TFIFile} from 'notebook/tfi/TFIConstants';
import TFIDAO from 'notebook/tfi/TFIDAO';
import BenchlingIcon from 'ui-library/icons/BenchlingIcon';
import LegacyCircularThrobber from 'ui-library/LegacyCircularThrobber';
import * as ModalContainer from 'ui-library/ModalContainer';
import Modal, {ModalBodyColor} from 'ui-library/modals/Modal';
import fuzzydate from 'util/fuzzydate';
import {formatBytes} from 'util/NameUtil';

const TFI_PREVIEW_MODAL_KEY = 'TFIPreviewModal';

interface Props {
  onRequestClose: (...args: Array<any>) => any;
  tfiFile: TFIFile;
}

type State = any;

class TFIPreviewModal extends React.Component<Props, State> {
  static open({tfiFile}: any): ReturnType<typeof ModalContainer.open> {
    return ModalContainer.open(
      TFI_PREVIEW_MODAL_KEY,
      <TFIPreviewModal
        onRequestClose={function () {
          ModalContainer.close(TFI_PREVIEW_MODAL_KEY);
        }}
        tfiFile={tfiFile}
      />
    );
  }

  override state: State = {
    loading: true,
  };

  override componentDidMount(): void {
    const $overlay = this.addOverlay();
    this.setState({$overlay});
    this.getPreview();
  }

  override componentWillUnmount(): void {
    return this.state.$overlay != null ? this.state.$overlay.remove() : undefined;
  }

  addOverlay = (): JQuery => {
    const $overlay = $('<div>').addClass('overlay');
    $('body').append($overlay);
    return $overlay;
  };

  getPreview = (): void => {
    TFIDAO.previewFile(this.props.tfiFile.accountId, this.props.tfiFile.id).done((response: any) => {
      // No URL in response indicates there is no preview to load
      this.setState({loading: response.url != null, previewUrl: response.url, mimetype: response.mimetype});
    });
  };

  renderModalHeader = (): JSX.Element => (
    <div className="tfi-modalHeader">
      <span className="tfi-modalClose" onClick={this.props.onRequestClose}>
        ×
      </span>
      <TFIAccountIcon className="tfi-accountIcon" accountType={this.props.tfiFile.accountType} />
      <div className="tfi-modalTitle">
        <h4>{this.props.tfiFile.name}</h4>
        <span>{`Last modified ${fuzzydate(this.props.tfiFile.modifiedAt)}`}</span>
        {/* TODO(T4997): Port to redesigned tour flow */}
        <div>To import this file, drag from the sidebar into an entry.</div>
      </div>
    </div>
  );

  override render(): JSX.Element {
    return (
      <div className="tfi-modalContainer">
        <Modal
          enableRedesign={false}
          modalBodyBgColor={ModalBodyColor.TRANSPARENT}
          onRequestClose={this.props.onRequestClose}
          large={true}
          suppressHeader={true}
          wrapInForm={false}
        >
          {this.renderModalHeader()}
          {this.state.loading ? (
            <div className="text-center tfi-modalSpinner">
              <LegacyCircularThrobber />
            </div>
          ) : undefined}
          {(() => {
            if (this.state.previewUrl != null) {
              if (this.state.mimetype != null && this.state.mimetype.indexOf('image/') !== -1) {
                return (
                  <img
                    className="tfi-modalImage"
                    src={this.state.previewUrl}
                    onLoad={() => {
                      this.setState({loading: false});
                    }}
                  />
                );
              } else {
                return (
                  <iframe
                    sandbox="allow-scripts"
                    src={this.state.previewUrl}
                    width="100%"
                    height={700}
                    style={!this.state.loading ? {backgroundColor: 'white'} : undefined}
                    onLoad={() => {
                      this.setState({loading: false});
                    }}
                  />
                );
              }
            } else if (!this.state.loading) {
              return (
                <div className="tfi-modalNoPreview">
                  <BenchlingIcon className="tfi-modalNoPreviewIcon" icon="file" />
                  <div>
                    {`${formatBytes(this.props.tfiFile.fileSize)} \u2022 Last modified ${fuzzydate(
                      this.props.tfiFile.modifiedAt
                    )}`}
                  </div>
                </div>
              );
            }
            return null;
          })()}
        </Modal>
      </div>
    );
  }
}

export default TFIPreviewModal;
